export default "__VITE_ASSET__bc17efa4__"